<!--
Author:
Create Time: 2020-04-13 09:22:08
Description: 房源档案选择框
-->
<template>
  <div class="com-populregister-select">
      <span>
          <el-input
            placeholder
            v-model="label"
            @focus="handleInputClick"
            :disabled="disabled"
            data-ignore-clearable="true"
            data-ignore-at-clear="handleClear"
            :title="label">
          <i
          class="el-icon-search el-input__icon"
          slot="suffix">
          </i></el-input>
      </span>

      <proRoomRegisterRef
        ref="proRoomRegisterRef"
        :visible="isproRoomRegisterRefVisible"
        :populIdCondition="populIdCondition"
        :houseListCondition="houseListCondition"
        :buildId="buildId"
        @confirm="handleproRoomRegisterRefConfirm"
        :multiple="multiple"
        @cancel="handleproRoomRegisterRefCancel"
        append-to-body
        :isCar="isCar"
        :isHouse="isHouse"
        width="65%"
      />
  </div>
</template>

<script>
export default {
  name: "proRoomRegisterSelect",
  props: {
    value: {
      type: [String, Array, undefined],
      default: () => ""
    },
    label: {
      type: String,
      default: () => ""
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    populIdCondition: {
      type: String,
      default: () => ""
    },
    houseListCondition: {
      type: String,
      default: () => ""
    },
    isCar: {
      type: Boolean,
      default: () => false
    },
    isHouse: {
      type: Boolean,
      default: () => false
    },
    buildId: {
      type: String,
      default: () => ""
    },
    houseId: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      isproRoomRegisterRefVisible: false
    };
  },
  computed: {
    multiple() {
      return Array.isArray(this.value);
    }
  },
  methods: {
    handleInputClick() {
      this.isproRoomRegisterRefVisible = true;
    },
    handleClear() {},
    handleproRoomRegisterRefConfirm(value) {
      let val = Array.isArray(value) ? value.map(o => o.id) : value.id;
      this.$emit("update:value", val, value);
      this.$emit("change", val, value);
      this.$emit("input", val, value);
      this.isproRoomRegisterRefVisible = false;
    },
    handleproRoomRegisterRefCancel() {
      this.isproRoomRegisterRefVisible = false;
    }
  }
};
</script>

<style scoped lang="less">
.com-populregister-select {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/proRoomRegister/proRoomRegisterSelect.vue